import { initialize, reset, SubmissionError } from 'redux-form'

import {
  getDataSource,
  getMe,
  getPrescriptions,
  getPhysiciansAndEkgStackCount,
  getPatients,
  getInterpretations,
  getActivity,
  postPatient,
  dataSourceClearError,
} from '../../store/appReducer'
import { ROUTES, DATASOURCES, FORMS, CLEAR_STATE, parseDateOfBirth, PATIENT_FILE_TABS } from '../../constants'
import { handleOnPatientClick } from '../../pages/PatientFile/module'
import { getMedantaConfigs, checkMedantaAPIFeatureEnabled } from 'configs'
import { fetchMedantaUHID } from '../../containers/ApiUrls'

// ------------------------------------
// Constants
// ------------------------------------
const PREFIX = 'AddNewPatient.'
export const DATA_REQUEST = `${PREFIX}DATA_REQUEST`
export const DATA_SUCCESS = `${PREFIX}DATA_SUCCESS`
export const DATA_FAILURE = `${PREFIX}DATA_FAILURE`
export const VALIDATE_MEDANTA_UHID_FAILED = `${PREFIX}VALIDATE_MEDANTA_UHID_FAILED`
export const VALIDATE_MEDANTA_UHID_SUCCESS = `${PREFIX}VALIDATE_MEDANTA_UHID_SUCCESS`

// ------------------------------------
// Actions
// ------------------------------------
export const dataRequest = () => ({
  type: DATA_REQUEST,
})
export const dataSuccess = () => ({
  type: DATA_SUCCESS,
})
export const dataFailure = () => ({
  type: DATA_FAILURE,
})
export const medantaUHIDValidationFailed = errTxt => ({
  type: VALIDATE_MEDANTA_UHID_FAILED,
  payload: errTxt,
})
export const medantaUHIDValidationSuccess = () => ({
  type: VALIDATE_MEDANTA_UHID_SUCCESS,
  payload: '',
})


// add patient handle for the CRO with dyanmic field
export const handleOnNewPatientCROFormSubmit = form => (dispatch, getState) => {
  const me = getDataSource(getState(), DATASOURCES.ME)

  const customFields = me && me.data && me.data.teams[0] && me.data.teams[0].teamPatientFields.filter(item => item.isCustom === true)

  dispatch(dataRequest())

  const newForm = Object.assign(
    {},
    {
      customParticipantID: form.customParticipantID,
      email: form.email,
    }
  )

  if (form.orderingPhysician) {
    newForm.orderingPhysicianMemberID = form.orderingPhysician.id
  }

  if (form.firstName) {
    newForm.firstName = form.firstName
  } else {
    // TODO: TEMP as backend requires firstName and lastName to be set. remove this else once backend is updated to match spec
    newForm.firstName = ' '
  }

  if (form.lastName) {
    newForm.lastName = form.lastName
  } else {
    // TODO: TEMP as backend requires firstName and lastName to be set. remove this else once backend is updated to match spec
    newForm.lastName = ' '
  }

  if (form.dob) {
    const { year, month, day } = parseDateOfBirth(form.dob, me)

    if (Number.isInteger(parseInt(year, 10)) && Number.isInteger(parseInt(month, 10)) && Number.isInteger(parseInt(day, 10))) {
      newForm.dob = `${year}-${month}-${day}`
    }
  }

  if (form.phone) {
    const strippedPhoneNumber = form.phone.replace(/[()-\s]/g, '') // remove anything but number
    newForm.phone = strippedPhoneNumber
  }

  if (form.sex) {
    newForm.sex = form.sex.value
  }

  if (form.implantedDevice) {
    newForm.implantedDevice = form.implantedDevice
  }

  if (form.notes) {
    newForm.notes = form.notes
  }


  if (customFields && customFields.length > 0) {
    // eslint-disable-next-line no-restricted-syntax
    for (const item of customFields) {
      newForm[item.fieldName] = form[item.fieldName]
    }
  }

  const meDataSource = getDataSource(getState(), DATASOURCES.ME)

  let promises

  // ensure we have team id
  if (meDataSource.data) {
    promises = Promise.resolve()
  } else {
    promises = dispatch(getMe())
  }

  return promises
    .then(() => {
      const {
        teams,
      } = me.data

      return dispatch(postPatient(teams[0].id, newForm))
        .then(patientId => {
          dispatch(reset(FORMS.ADD_NEW_PATIENT_FORM))
          dispatch(dataSourceClearError(DATASOURCES.PATIENT))
          dispatch(dataSuccess())
          dispatch(handleOnPatientClick(true, true, { patientId }, PATIENT_FILE_TABS.OVERVIEW))
        })
    })
    .catch(err => {
      console.log('Err--', err)
      const error = JSON.parse(err)
      dispatch(initialize(FORMS.ADD_NEW_PATIENT_FORM, form))
      dispatch(dataFailure())
      throw new SubmissionError({ [error.type]: error.msg })
    })
}


export const handleOnNewPatientFormSubmit = form => (dispatch, getState) => {
  const me = getDataSource(getState(), DATASOURCES.ME)
  const medantaConfigs = getMedantaConfigs(me)
  const isMedantaAPIEnabled = checkMedantaAPIFeatureEnabled(me)

  const customFields = me && me.data && me.data.teams[0] && me.data.teams[0].teamPatientFields.filter(item => item.isCustom === true)

  dispatch(dataRequest())

  const newForm = Object.assign(
    {},
    {
      customParticipantID: form.customParticipantID,
      email: form.email,
    }
  )

  if (form.orderingPhysician) {
    newForm.orderingPhysicianMemberID = form.orderingPhysician.id
  }

  if (form.firstName) {
    newForm.firstName = form.firstName
  } else {
    // TODO: TEMP as backend requires firstName and lastName to be set. remove this else once backend is updated to match spec
    newForm.firstName = ' '
  }

  if (form.lastName) {
    newForm.lastName = form.lastName
  } else {
    // TODO: TEMP as backend requires firstName and lastName to be set. remove this else once backend is updated to match spec
    newForm.lastName = ' '
  }

  if (form.dob) {
    const { year, month, day } = parseDateOfBirth(form.dob, me)

    if (Number.isInteger(parseInt(year, 10)) && Number.isInteger(parseInt(month, 10)) && Number.isInteger(parseInt(day, 10))) {
      newForm.dob = `${year}-${month}-${day}`
    }
  }

  if (form.phone) {
    const strippedPhoneNumber = form.phone.replace(/[()-\s]/g, '') // remove anything but number
    newForm.phone = strippedPhoneNumber
  }

  if (form.sex) {
    newForm.sex = form.sex.value
  }

  if (form.implantedDevice) {
    newForm.implantedDevice = form.implantedDevice
  }

  if (form.notes) {
    newForm.notes = form.notes
  }

  const meDataSource = getDataSource(getState(), DATASOURCES.ME)

  if (customFields && customFields.length > 0) {
    // eslint-disable-next-line no-restricted-syntax
    for (const item of customFields) {
      newForm[item.fieldName] = form[item.fieldName]
    }
  }

  let promises

  // ensure we have team id
  if (meDataSource.data) {
    promises = Promise.resolve()
  } else {
    promises = dispatch(getMe())
  }

  if (isMedantaAPIEnabled && medantaConfigs !== null && medantaConfigs.UHIDCheck) {
    // promises = new Promise((resolve, reject) => {
    return dispatch(fetchMedantaUHID(form.customParticipantID))
      .then(res => {
        // 201 - Invalid UHID length , 202 - Invalid UHID
        if (res.ErrorCode === '201' || res.ErrorCode === '202') {
          dispatch(dispatch(medantaUHIDValidationFailed(res.ErrorMessage)))
          dispatch(initialize(FORMS.ADD_NEW_PATIENT_FORM, form))
          dispatch(dataFailure())
          // clear the UHID Failed status to remove the Error in page
          setTimeout(() => {
            dispatch(dispatch(medantaUHIDValidationSuccess()))
          }, 2000)
        } else if (res.PatientUHID !== null) {
          // console.log('Res::', res)
          dispatch(dispatch(medantaUHIDValidationSuccess()))
          // PROCESS FOR SAVE --- NEW PATIENT
          return promises
            .then(() => {
              const {
                teams,
              } = me.data

              return dispatch(postPatient(teams[0].id, newForm))
                .then(patientId => {
                  dispatch(reset(FORMS.ADD_NEW_PATIENT_FORM))
                  dispatch(dataSourceClearError(DATASOURCES.PATIENT))
                  dispatch(dataSuccess())
                  dispatch(handleOnPatientClick(true, true, { patientId }, PATIENT_FILE_TABS.OVERVIEW))
                })
            })
            .catch(err => {
              const error = JSON.parse(err)
              dispatch(initialize(FORMS.ADD_NEW_PATIENT_FORM, form))
              dispatch(dataFailure())
              throw new SubmissionError({ [error.type]: error.msg })
            })
        }
      })
  } else {
    // Medanta Check Is Disabled, PROCESS FOR SAVE --- NEW PATIENT
    return promises
      .then(() => {
        const {
          teams,
        } = me.data

        return dispatch(postPatient(teams[0].id, newForm))
          .then(patientId => {
            dispatch(reset(FORMS.ADD_NEW_PATIENT_FORM))
            dispatch(dataSourceClearError(DATASOURCES.PATIENT))
            dispatch(dataSuccess())
            dispatch(handleOnPatientClick(true, true, { patientId }, PATIENT_FILE_TABS.OVERVIEW))
          })
      })
      .catch(err => {
        console.log('Err--', err)
        const error = JSON.parse(err)
        dispatch(initialize(FORMS.ADD_NEW_PATIENT_FORM, form))
        dispatch(dataFailure())
        throw new SubmissionError({ [error.type]: error.msg })
      })
  }
}
export const getAddNewPatientData = (forceUpdate = false) => (dispatch, getState) => {
  dispatch(dataRequest())
  const meDataSource = getDataSource(getState(), DATASOURCES.ME)

  let promises

  if (meDataSource.data && !forceUpdate) {
    promises = Promise.resolve()
  } else {
    promises = dispatch(getMe())
  }

  return promises
    .then(() => {
      const me = getDataSource(getState(), DATASOURCES.ME)

      const {
        teams,
      } = me.data

      return Promise.all([
        dispatch(getPhysiciansAndEkgStackCount(teams[0].id)),
        dispatch(dataSourceClearError(DATASOURCES.PATIENT)),
      ])
    })
    .then(() => dispatch(dataSuccess()))
    .catch(err => {
      console.log('getAddNewPatientData', err)
      dispatch(dataFailure())
    })
}

const initialState = {
  dataIsFetching: false,
  dataLastUpdated: null,
  medantaUHIDValidation: {
    Error: false,
    msg: '',
  },
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [DATA_REQUEST]: (state, action) => ({
    ...state, dataIsFetching: true,
  }),
  [DATA_SUCCESS]: (state, action) => ({
    ...state, dataIsFetching: false, dataLastUpdated: new Date(),
  }),
  [DATA_FAILURE]: (state, action) => ({
    ...state, dataIsFetching: false, dataLastUpdated: new Date(),
  }),
  [CLEAR_STATE]: (state, action) => ({ ...initialState }),
  [VALIDATE_MEDANTA_UHID_FAILED]: (state, action) => ({
    ...state, dataIsFetching: false, dataLastUpdated: new Date(), medantaUHIDValidation: { Error: true, msg: action.payload },
  }),
  [VALIDATE_MEDANTA_UHID_SUCCESS]: (state, action) => ({
    ...state, dataIsFetching: false, dataLastUpdated: new Date(), medantaUHIDValidation: { Error: false, msg: action.payload },
  }),
}

// ------------------------------------
// Reducer
// ------------------------------------
export default function addNewPatientReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/legacy/pages/AddNewPatient/module.js